<template>
  <div>
    <a-row>
      <a-col
        :sm="{ span: 24 }"
        :md="{ span: 24 }"
        :xl="{ span: 20, offset: 2 }"
      >
        <a-spin :spinning="spinning" tip="Loading...">
          <a-card size="small" style="width: 100%">
            <div slot="title" style="font-size: 20px">Basic Information</div>
            <a-row>
              <a-col
                :sm="{ span: 24 }"
                :md="{ span: 14 }"
                :xl="{ span: 14 }"
                style="padding-right: 40px; line-height: 40px"
              >
                <div>
                  <a-icon type="medicine-box" style="color: orange" />
                  <span
                    style="
                      color: orange;
                      margin-left: 3px;
                      font-size: 18px;
                      font-weight: bolder;
                    "
                    >CP</span
                  >
                  <span
                    style="
                      font-size: 20px;
                      color: black;
                      font-weight: bolder;
                      margin-left: 10px;
                    "
                    >{{ this.$route.query.dName }}</span
                  >
                </div>
                <div>
                  <span
                    style="color: orange; font-size: 18px; font-weight: bolder"
                    >Synonym:</span
                  >
                  <span style="font-size: 16px; margin-left: 10px">{{
                    this.drugInfo["Alias"]
                  }}</span>
                </div>
                <div>
                  <span
                    style="color: orange; font-size: 18px; font-weight: bolder"
                    >Description:
                  </span>
                  <span style="font-size: 16px; margin-left: 10px">{{
                    this.drugInfo["Description"]
                  }}</span>
                </div>
                <a-divider />
                <div style="margin-top: -10px; font-weight: bolder">
                  Biological function:
                </div>
                <div>
                  <span
                    style="color: orange; font-size: 18px; font-weight: bolder"
                    >MOA:</span
                  >
                  <span style="font-size: 16px; margin-left: 10px">{{
                    this.drugInfo["MOA"]
                  }}</span>
                </div>
                <div>
                  <span
                    style="color: orange; font-size: 18px; font-weight: bolder"
                    >CMap class:
                  </span>
                  <span style="font-size: 16px; margin-left: 10px">{{
                    this.drugInfo[
                      "CMapClass;font-size: 18px;font-weight:bolder"
                    ]
                  }}</span>
                </div>
                <div>
                  <span
                    style="color: orange; font-size: 18px; font-weight: bolder"
                    >Protein target:
                  </span>
                  <span style="font-size: 16px; margin-left: 10px">{{
                    this.drugInfo["ProteinTarget"]
                  }}</span>
                </div>
              </a-col>
              <a-col
                :sm="{ span: 24 }"
                :md="{ span: 10 }"
                :xl="{ span: 10 }"
                style="text-align: left; margin-top: -6px"
              >
                <a-tabs default-active-key="1" @change="callback" size="small">
                  <a-tab-pane key="1" tab="CMap">
                    <span style="color: orange">ID:</span>
                    <span
                      style="
                        color: black;
                        font-weight: bolder;
                        margin-left: 10px;
                      "
                      >{{ this.$route.query.drugid }}</span
                    >
                  </a-tab-pane>
                  <a-tab-pane key="2" tab="SMILES" force-render>
                    {{ this.drugInfo["SMILES"] }}
                  </a-tab-pane>
                </a-tabs>
                <div
                  style="
                    text-align: center;
                    height: 300px;
                    overflow-y: auto;
                    padding-top: 20px;
                  "
                >
                  <img :src="this.src" width="50%" />
                </div>
              </a-col>
            </a-row>
          </a-card>
        </a-spin>
      </a-col>
      <a-col
        :sm="{ span: 24 }"
        :md="{ span: 24 }"
        :xl="{ span: 20, offset: 2 }"
        style="margin-top: 10px"
      >
        <a-card size="small" style="width: 100%">
          <div slot="title" style="font-size: 20px">
            Prediction of Targeted Genes
          </div>
          <a-alert banner>
            <span slot="message">
              <i style="font-weight: bolder">Note :</i> A target gene identified
              across multiple datasets and assigned a higher score is more
              likely to be a genuine target of this inhibitor.</span
            ></a-alert
          >
          <a-tabs>
            <a-tab-pane key="1" tab="Targeted genes from Perturb-Seq"
              ><targetGene
            /></a-tab-pane>
            <a-tab-pane
              key="2"
              tab="Targeted genes from Bulk perturbation RNA-Seq"
            >
              <targetGeneBulk />
            </a-tab-pane>
          </a-tabs>
        </a-card>
      </a-col>
    </a-row>
  </div>
</template>
<script>
import axios from "axios";
import targetGene from "./drugModel_targetGene.vue";
import targetGeneBulk from "./drugModel_targetGeneBulk.vue";

export default {
  components: { targetGene, targetGeneBulk },
  mounted() {
    axios
      .get(
        "http://research.gzsys.org.cn/perturbdb/API/drug/drugModel_drugDetails.php",
        {
          params: {
            drugid: this.$route.query.drugid,
          },
        }
      )
      .then((response) => {
        this.drugInfo = response.data[0];
        this.src =
          "http://research.gzsys.org.cn/perturbdb/image/drug/" +
          this.drugInfo["CMapID"] +
          ".png";
        this.spinning = false;
      });
  },
  data() {
    return {
      drugInfo: {},
      src: "",
      spinning: true,
    };
  },
};
</script>
<style></style>
